import TC from "components/Stacker/constants/ToggleConstants"

export const toggleToggle = (id, toggleState) => {
  return {
    type: TC.TOGGLE_TOGGLE,
    payload: {
      id,
      toggleState,
    },
  }
}
